import { render } from "./waterfallGallery.vue?vue&type=template&id=0a1c8963&scoped=true"
import script from "./waterfallGallery.vue?vue&type=script&lang=js"
export * from "./waterfallGallery.vue?vue&type=script&lang=js"

import "./waterfallGallery.vue?vue&type=style&index=0&id=0a1c8963&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1c8963"]])

export default __exports__